import { ascend, isNil, map, prop, sort } from 'ramda';
import { CMSGroupMode } from '@/api/cms/base';
import type { CMSGameCategory } from '@/api/cms/gameCategories';
import type { GameCategory, SubGameCategory } from '@/api/games';
import { ImageComponent } from '@/components/Image';
import { GameStaticCategories } from './game';

const defineCategoryTitle = (id: string, title: string) => {
  if (id === GameStaticCategories.Favorites)
    return (
      <ImageComponent
        alt="heart"
        height={24}
        src="/emojis/heart.webp"
        width={24}
      />
    );
  if (id === GameStaticCategories.Recent)
    return (
      <ImageComponent
        alt="clock"
        height={24}
        src="/emojis/clock.webp"
        width={24}
      />
    );

  return title;
};

export const formatCategories = (
  isAuthenticated: boolean,
  defaultCategories: Map<string, GameCategory>
) =>
  map(
    ({
      title,
      categoryIdAuth,
      categoryIdNotAuth,
      defaultCategoryId,
      order,
      groupsExcludeMode,
      groupsExclude,
      groupsInclude,
      groupsIncludeMode,
      subCategories,
      ...rest
    }: CMSGameCategory) => {
      const id = isAuthenticated ? categoryIdAuth : categoryIdNotAuth;

      const titleElement = defineCategoryTitle(id, title);

      const sortedSubCategories = sort<SubGameCategory>(ascend(prop('order')))(
        subCategories
      );

      return {
        ...rest,
        id,
        categoryIdAuth,
        categoryIdNotAuth,
        defaultCategoryId,
        title: titleElement,
        href:
          defaultCategoryId === GameStaticCategories.Lobby
            ? '/'
            : `/games/${defaultCategoryId}#gamesSection`,
        order: isNil(order) ? defaultCategories.size - 1 : order,
        groupsIncludeMode: groupsIncludeMode || CMSGroupMode.AND,
        groupsInclude: groupsInclude || null,
        groupsExcludeMode: groupsExcludeMode || CMSGroupMode.AND,
        groupsExclude: groupsExclude || null,
        subCategories: sortedSubCategories || [],
        gamesCount: defaultCategories.get(id)?.gamesCount ?? 0,
      };
    }
  );
